import { render, staticRenderFns } from "./SerialEmbed.vue?vue&type=template&id=71715660&scoped=true&"
import script from "./SerialEmbed.vue?vue&type=script&lang=ts&"
export * from "./SerialEmbed.vue?vue&type=script&lang=ts&"
import style0 from "./SerialEmbed.vue?vue&type=style&index=0&id=71715660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71715660",
  null
  
)

export default component.exports